import { Component, OnInit } from '@angular/core';
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { CompaniesService } from '../../../services/companies.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { Search } from '../../../models/Search.model';

@Component({
    selector: 'app-company-temporary',
    templateUrl: './company-temporary.component.html',
    styleUrls: ['./company-temporary.component.css']
})
export class CompanyTemporaryComponent implements OnInit {
    loading: boolean;
    companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
    companyGroupSearchModel: CompanyGroupSearch;
    companies: any[];
    companyTemporarySearch: Search = new Search();
    companyForm: FormGroup;
    commonHelper: CommonHelper = new CommonHelper();
    companyGroupAux: CompanyGroup = new CompanyGroup();
    email: String = '';

    dropDownProducts: any;

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 5;
    currentPage: number = 1;

    constructor(private companiesService: CompaniesService,
        private formBuilder: FormBuilder,
        private router: Router,
        private localStorage: LocalStorage,
        private tostr: ToastsManager) { }

    async ngOnInit() {
        this.loading = true;

        await this.search(1);

        this.companyGroupSearchModel = new CompanyGroupSearch();
        this.companyGroupSearchModel.allItems = true;
        this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);

        this.loading = false;
    }

    async search(page?: number) {
        this.loading = true;
        this.currentPage = page ? page : 1;
        this.companyTemporarySearch.skip = (page - 1) * this.companyTemporarySearch.limit;
        this.companies = await this.companiesService.searchTemporaryCompanies(this.companyTemporarySearch);
        this.totalItems = this.companyTemporarySearch.totalItems;
        this.localStorage.persist('companiesTemporary', this.companyTemporarySearch);
        this.loading = false;
    }

    async approvedCompany(c: any){
        try {
            if(this.companyGroupAux._id != '' && this.companyGroupAux._id != undefined){
                this.companyGroupAux.name = this.companyGroups.find(x => x._id === this.companyGroupAux._id).name;

                let companyApproval = { ...c };
                companyApproval["companyGroup"] = { ...this.companyGroupAux };

                this.clearGroup();

                this.loading = true;
                let res = await this.companiesService.approvalTemporaryCompany(companyApproval);
                if(res._id){
                    this.loading = false;
                    this.tostr.success('A empresa foi incluída no Financial e integrada com SAP', 'Empresa aprovada');
                    await this.search(1);
                } else {
                    this.loading = false;
                    this.tostr.warning('Erro ao aprovar empresa');
                }
            }
        } catch (err){
            this.loading = false;
            console.log(err);
            this.tostr.warning('Erro ao aprovar empresa');
        }
    }

    clearGroup(){
        this.companyGroupAux._id = '';
        this.companyGroupAux.name = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-temporary/company-temporary.component.ts